import { BRAND } from '../brand';
import { ENTITY, EFFECTIVE_DATE, VERSION, CONTACT_EMAIL } from './meta';

export const TERMS = {
  title: '이용약관',
  version: VERSION,
  effectiveDate: EFFECTIVE_DATE,
  sections: [
    {
      id: 'purpose',
      heading: '제1조 (목적)',
      body: [
        `본 약관은 ${ENTITY}(이하 "회사")가 제공하는 Apple 파트너사 교육 플랫폼 ${BRAND}(이하 "서비스")의 이용 조건 및 절차, 회사와 이용자의 권리·의무 및 책임사항을 규정함을 목적으로 합니다.`,
      ],
    },
    {
      id: 'definitions',
      heading: '제2조 (정의)',
      list: [
        '"서비스"란 회사가 개발·운영하는 AI 기반 역할극 교육·학습·평가 플랫폼을 의미합니다.',
        '"이용자"란 파트너사의 초대를 받아 가입하고 본 서비스를 이용하는 파트너사 임직원을 의미합니다.',
        '"파트너사"란 회사와 교육 서비스 계약을 체결하고 소속 임직원을 서비스에 초대하는 법인을 의미합니다.',
        '"관리자"란 파트너사가 지정하여 소속 이용자의 계정 승인 및 학습 현황을 관리하는 이용자를 의미합니다.',
      ],
    },
    {
      id: 'amendment',
      heading: '제3조 (약관의 효력 및 변경)',
      body: [
        '본 약관은 서비스 화면에 게시함으로써 효력이 발생합니다.',
        '회사는 관련 법령을 위배하지 않는 범위에서 본 약관을 변경할 수 있으며, 변경 시 시행 7일 전부터 서비스 내 공지를 통해 안내합니다. 이용자에게 불리한 변경의 경우에는 30일 전에 안내합니다.',
      ],
    },
    {
      id: 'service',
      heading: '제4조 (서비스의 내용)',
      body: ['회사는 다음의 서비스를 제공합니다.'],
      list: [
        'AI 고객과의 음성 역할극 시뮬레이션',
        '역할극 수행에 대한 자동 평가 및 피드백 제공',
        '제품 지식 퀴즈 및 학습 대시보드 제공',
        '파트너사 관리자를 위한 교육 현황 관리 기능',
      ],
    },
    {
      id: 'operation',
      heading: '제5조 (회사의 운영 권한)',
      body: [
        '본 서비스의 운영 주체는 회사이며, 서비스 정책 수립, 시스템 유지보수 및 데이터 관리에 대한 결정 권한은 회사에 있습니다.',
        '회사는 서비스의 내용을 개선하기 위하여 기능을 추가·변경할 수 있으며, 중대한 변경이 있는 경우 사전에 공지합니다.',
      ],
    },
    {
      id: 'obligations',
      heading: '제6조 (이용자의 의무)',
      list: [
        '이용자는 본 약관 및 개인정보처리방침을 준수하여야 합니다.',
        '이용자는 계정 정보를 타인에게 유출하거나 공유하여서는 안 되며, 타인의 계정으로 서비스를 이용하여서는 안 됩니다.',
        '이용자는 평가 과정에서 본인이 직접 수행하여야 하며, 제3자를 대신 참여시켜서는 안 됩니다.',
        '이용자는 서비스를 통해 제공되는 교육 콘텐츠 및 평가 기준을 회사의 사전 승낙 없이 외부에 공개하거나 복제·배포하여서는 안 됩니다.',
      ],
    },
    {
      id: 'consent',
      heading: '제7조 (가입 및 동의)',
      body: [
        '파트너사 관리자에 의해 초대된 이용자라 하더라도, 가입 절차에서 이용자 본인이 ① 이용약관 동의, ② 개인정보 수집·이용 동의, ③ 개인정보 제3자 제공 동의의 세 항목에 각각 개별적으로 동의하여야 가입이 진행됩니다. 어느 하나에 대한 동의가 다른 항목에 대한 동의를 대신하지 않습니다.',
        '세 항목은 모두 필수 항목이며, 각 항목의 구체적인 내용은 본 약관 및 개인정보처리방침에서 확인하실 수 있습니다.',
        '이용자의 가입은 소속 파트너사 관리자의 승인을 거쳐 완료됩니다.',
      ],
    },
    {
      id: 'restriction',
      heading: '제8조 (서비스 이용의 제한)',
      body: [
        '회사는 이용자가 제6조의 의무를 위반한 경우 사전 통지 후 서비스 이용을 제한하거나 계정을 정지할 수 있습니다. 다만 긴급한 사유가 있는 경우에는 조치 후 통지할 수 있습니다.',
        '소속 파트너사와 회사 간의 교육 서비스 계약이 종료된 경우, 해당 파트너사 소속 이용자의 서비스 이용은 종료됩니다.',
      ],
    },
    {
      id: 'liability',
      heading: '제9조 (책임의 한계)',
      body: [
        '회사는 천재지변, 통신 사업자의 장애 등 회사의 합리적인 통제를 벗어난 사유로 서비스를 제공할 수 없는 경우 그에 대한 책임을 지지 않습니다.',
        '서비스가 제공하는 AI 평가 결과는 교육 및 역량 개발을 위한 참고 자료이며, 회사는 해당 결과가 파트너사의 인사 평가에 활용됨으로써 발생하는 결과에 대하여 책임을 지지 않습니다.',
      ],
    },
    {
      id: 'law',
      heading: '제10조 (준거법 및 관할)',
      body: [
        '본 약관은 대한민국 법령에 따라 해석되며, 서비스 이용과 관련하여 분쟁이 발생한 경우 회사의 본점 소재지를 관할하는 법원을 관할 법원으로 합니다.',
        `본 약관에 관한 문의는 ${CONTACT_EMAIL}로 접수하실 수 있습니다.`,
      ],
    },
  ],
};
